/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

"use client";

import cn from "classnames";
import type { FC } from "react";
import { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";

import type { BodyProps, TitleProps } from "./SettingsPopupContent/inject";
import { injectBodyNode, injectTitleNode } from "./SettingsPopupContent/inject";

interface DesktopPopupProps {
  open: boolean;
  onClose: () => void;
  title?: TitleProps;
  body?: BodyProps;
  openOnRight?: boolean;
  width?: "normal" | "wide";
}

export const DesktopPopup: FC<DesktopPopupProps> = ({
  open,
  onClose,
  title,
  body,
  openOnRight,
  width = "normal",
}) => {
  const [isRendered, setRendered] = useState(open);

  useEffect(() => {
    if (open) {
      setRendered(true);
      // Disable scrolling on the body
      document.body.style.overflow = "hidden";
    } else {
      setTimeout(() => {
        setRendered(false);
        // Re-enable scrolling
        document.body.style.overflow = "unset";
      }, 500);
    }
  }, [open]);

  return isRendered ? (
    <div
      className={`hidden md:flex fixed inset-0 flex p-2 ${
        openOnRight ? "justify-end" : "items-center justify-center"
      } bg-overlay-bg/80 transition-opacity duration-100 z-50 ${
        open ? "opacity-100 animate-fade" : "opacity-0"
      }`}
      onClick={onClose}
    >
      <div
        className={cn(
          "relative flex flex-col p-6 pb-2 bg-white rounded-3xl shadow-lg overflow-hidden transition-opacity duration-100",
          {
            "max-w-3xl": width === "wide",
            "w-400-px": width !== "wide" && !openOnRight,
            "w-412-px": openOnRight,
          },
          {
            "opacity-100": open,
            "opacity-0": !open,
          }
        )}
        onClick={(event) => event.stopPropagation()}
      >
        <IoClose
          className="absolute top-7 right-5 z-10 w-6 h-6 text-tertiary-text cursor-pointer"
          onClick={onClose}
          width={16}
          height={16}
        />
        {title && (
          <div className="w-full font-bold mb-6">{injectTitleNode(title)}</div>
        )}
        {injectBodyNode(body)}
      </div>
    </div>
  ) : null;
};
